import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { City, District, Municipality, Voivodeship } from '@interfaces';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-partial-residence-address',
  templateUrl: './partial-residence-address.component.html',
  styleUrls: ['./partial-residence-address.component.scss'],
  standalone: false,
})
export class PartialResidenceAddressComponent {
  @Input() controls: { [key: string]: FormControl };
  @Input() mode: 'foreigner' | 'employee';
  @Input() voivodeships$: Observable<Voivodeship[]>;
  @Input() districts$: Observable<District[]>;
  @Input() municips$: Observable<Municipality[]>;
  @Input() cities$: Observable<City[]>;
  @Input() loadingDistricts$: Observable<boolean>;
  @Input() loadingMunicips$: Observable<boolean>;
  @Input() loadingCities$: Observable<boolean>;
  @Input() lookingForVoivodeship = false;
  @Input() voivoIsBeeingUsed = false;
  @Input() userACKDocumentsReset = false;
  @Input() showDivider = true;
  @Input() warningLayout: 'compact' | 'spaced' = 'spaced';
  @Input() voivodeshipSpinnerClass: 'loading-wrapper' | null = 'loading-wrapper';
  @Input() voivodeshipSpinnerId: string | null = null;
  @Input() voivodeshipSpinnerDiameter = 25;
  @Input() trapVoivodeshipTab = false;
  @Input() trapWarningButtonTab = false;

  @Output() voivoChangeAcknowledged: EventEmitter<void> = new EventEmitter<void>();
  @Output() lastFieldTabPressed: EventEmitter<void> = new EventEmitter<void>();

  public onTab(event: Event, shouldTrap: boolean): void {
    if (!shouldTrap) {
      return;
    }

    this.lastFieldTabPressed.emit();
    event.preventDefault();
    event.stopPropagation();
  }
}
